var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"line"}),_c('div',{staticClass:"bottom",staticStyle:{"padding-top":"0"}},[_c('div',{staticClass:"symbol"}),_c('span',{staticClass:"symboltext"},[_vm._v("免责说明:")]),_c('div',{staticClass:"bottomText"},[_vm._v("本案例仅用于说明"),_c('common-data',{attrs:{"name":"appShortName_37"}}),_vm._v("量化功能的使用方法，不构成任何投资建议。")],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }